// extracted by mini-css-extract-plugin
export default {"blockCreditPointsTag":"block-credit-points-tag_blockCreditPointsTag__TJPBq"};